// Used for Project-listing, artist-listing, news-listing

import MapManager from "./Map"; // Adjust the path as necessary

class FilterListing {
    constructor(formSelector, mapManager, useFile = false) {
        //elements
        this.form = document.querySelector(formSelector);
        this.container = document.querySelector(".listing-feed");
        this.featuredTemplate = document.getElementById("featured-content");
        this.paginationContainer = document.querySelector(".pagination");
        this.filterCountResetEl = document.querySelector(".filter-count-reset");

        //map
        this.mapManager = mapManager;
        this.customInfoWindow = document.getElementById("custom-info-window");

        //data
        this.jsonData = [];
        this.useFile = useFile; //set jsonData location

        //pagination
        this.currentIndex = 0;
        this.cardsPerPage = this.featuredTemplate ? 8 : 9;

        //filters
        this.checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
        this.filteredData = [];
        this.activeFilters = 0;

        //buttons
        this.showFiltersButton = document.querySelector(
            ".show-filters--button",
        );
        this.surpriseMeButton = document.querySelector(".surprise-me");
        this.resetFiltersButton = document.querySelector(".reset-filters");
        this.loadMoreButton = this.createLoadMoreButton();
        this.showMoreFiltersButtons = document.querySelectorAll(
            "[data-show-more-filters]",
        );

        // Start the initialization process
        this.init();
    }

    async init() {
        if (!this.container || !this.form) return;
        this.jsonData = await this.fetchJsonData(this.useFile);
        if (!this.jsonData) return;
        this.filteredData = this.jsonData;

        this.renderCards();
        this.setupEventListeners();
    }

    async fetchJsonData(useFile) {
        const jsonDataElement = document.getElementById("json-data");

        if (useFile) {
            // Attempt to fetch JSON data from the server
            const cacheBustingUrl =
                "/wp-content/uploads/news.json?v=" + new Date().getTime();

            try {
                const response = await fetch(cacheBustingUrl);

                if (response.ok) {
                    const jsonData = await response.json();
                    console.log("jsonData", jsonData);
                    return jsonData; // Return the data fetched from the server
                } else {
                    console.error(
                        "Error fetching JSON from server:",
                        response.statusText,
                    );
                }
            } catch (error) {
                console.error("Network error while fetching JSON:", error);
            }
        }

        // Fallback to parsing JSON data from the HTML element
        console.log("jsonData", JSON.parse(jsonDataElement.innerHTML));
        return jsonDataElement ? JSON.parse(jsonDataElement.innerHTML) : [];
    }

    setupEventListeners() {
        this.setupCheckboxListener();
        this.setupSurpriseMeButton();
        this.setupResetFilters();
        this.setupToggleFilterCountEl();
        this.setupSwitchView();
        this.setupShowMoreFiltersButtons();
    }

    // Shuffle the JSON data array
    static shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]]; // Swap elements
        }
    }

    // This was the old method of tags needing to match to show rather then below this to show all posts if 1 tag is selected. 
    // static getMatchingData(selectedFilters, jsonData) {
    //     console.log("selectedFilters", selectedFilters);
    //     if (Object.values(selectedFilters).length) {
    //         return jsonData.filter((item) => {
    //             return Object.keys(selectedFilters).every((filterKey) => {
    //                 // If the filter is not empty, check if it matches
    //                 if (selectedFilters[filterKey].length > 0) {
    //                     // If the item doesn't have the corresponding field, it doesn't match
    //                     if (!item[filterKey]) {
    //                         return false;
    //                     }

    //                     // Ensure every selected value is present in the item's field (e.g., item.theme, item.location)
    //                     return selectedFilters[filterKey].every((value) =>
    //                         item[filterKey].includes(value),
    //                     );
    //                 }
    //                 // If the filter array is empty, it doesn't affect the filtering (always matches)
    //                 return true;
    //             });
    //         });
    //     } else {
    //         return jsonData;
    //     }
    // }

    static getMatchingData(selectedFilters, jsonData) {
        console.log("selectedFilters", selectedFilters);
        if (Object.keys(selectedFilters).length) {
            return jsonData.filter((item) => {
                return Object.keys(selectedFilters).some((filterKey) => {
                    if (selectedFilters[filterKey].length > 0) {
                        if (!item[filterKey]) {
                            return false;
                        }
                        return selectedFilters[filterKey].some((value) =>
                            item[filterKey].includes(value),
                        );
                    }
                    return false;
                });
            });
        } else {
            return jsonData;
        }
    }

    static getSelectedFilters(formElement) {
        const formData = new FormData(formElement);
        let query = {};
        for (const pair of formData.entries()) {
            if (pair[1] && pair[1] != "undefined") {
                // Remove '[]' from the key name (like 'theme[]' -> 'theme')
                const cleanKey = pair[0].replace(/\[\]$/, "");
                query[cleanKey] = formData.getAll(pair[0]); // Collect all values for the same key
            }
        }
        //console.log('query', query)
        return query; // Return the selected values object
    }

    setupShowMoreFiltersButtons() {
        if (!this.showMoreFiltersButtons.length) return;

        this.showMoreFiltersButtons.forEach((button) => {
            button.addEventListener("click", function (e) {
                const id = e.currentTarget.dataset.showMoreFilters;
                const expanded =
                    e.currentTarget.getAttribute("aria-expanded") === "true";

                const buttons = document.querySelectorAll(
                    "[data-show-more-filters='" + id + "']",
                );
                buttons.forEach((button) => {
                    button.setAttribute("aria-expanded", !expanded);
                });
            });
        });
    }

    // Listen for filter changes
    setupCheckboxListener() {
        // Attach event listener to the form
        this.form.addEventListener("change", (e) => {
            // Check if the target is a checkbox and it’s inside the form
            if (e.target && e.target.type === "checkbox") {
                this.currentIndex = 0;
                this.filterCards();

                // Toggle active class on label associated with the checkbox
                const label = e.target.nextElementSibling;
                if (label) {
                    label.classList.toggle("active", e.target.checked);
                }

                // Update the filter count after each change
                this.filterCount();
                const hasActiveFilters = this.activeFilters !== 0;

                this.filterCountResetEl.style.display = hasActiveFilters
                    ? "flex"
                    : "none";
            }
        });
    }

    // Suprise me functionality
    setupSurpriseMeButton() {
        this.surpriseMeButton.addEventListener("click", () => {
            FilterListing.shuffleArray(this.jsonData);
            this.currentIndex = 0;
            this.cardsPerPage = this.featuredTemplate ? 8 : 9;
            this.filterCards();
        });
    }

    // Reset all filters/ map pins and modal
    setupResetFilters() {
        this.resetFiltersButton.addEventListener("click", () => {
            const checkboxes = this.form.querySelectorAll(
                'input[type="checkbox"]',
            );

            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
                const label = checkbox.nextElementSibling;
                if (label) {
                    label.classList.remove("active");
                }
            });

            //hide modal
            this.customInfoWindow.style.display = "none";

            this.currentIndex = 0;
            this.filterCount();
            this.cardsPerPage = this.featuredTemplate ? 8 : 9;
            this.filterCards();
            this.filterCountResetEl.style.display = "none";

            // Reset the map's zoom level
            if (this.mapManager) {
                this.mapManager.resetZoom();
            }
        });
    }

    // Toggle - Filter count/reset element
    setupToggleFilterCountEl() {
        this.filterCountResetEl.style.display = "none"; // Set initial state
    }

    // Grid or Map view switcher
    setupSwitchView() {
        const switchViewButtons = document.querySelectorAll(
            ".view-options button",
        );

        switchViewButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const buttonRelatedElement = document.getElementById(
                    button.getAttribute("aria-controls"),
                );

                // Remove 'active' class from all buttons
                switchViewButtons.forEach((btn) => {
                    const btnRelatedElement = document.getElementById(
                        btn.getAttribute("aria-controls"),
                    );
                    btn.setAttribute("aria-expanded", "false");
                    btnRelatedElement.setAttribute("aria-expanded", "false");
                });

                // Add 'active' class to the clicked button
                button.setAttribute("aria-expanded", "true");
                buttonRelatedElement.setAttribute("aria-expanded", "true");

                // Toggle pagination container visibility
                const isMapView =
                    button.getAttribute("aria-controls") === "view-map";
                this.paginationContainer.style.display = isMapView
                    ? "none"
                    : "block";

                // Disable or enable the surprise-me button based on the view
                this.surpriseMeButton.disabled = isMapView;
                this.surpriseMeButton.style.display = isMapView
                    ? "none"
                    : "inline-flex";
            });
        });
    }

    // Count active filters
    filterCount() {
        this.activeFilters = Array.from(this.checkboxes).filter(
            (checkbox) => checkbox.checked,
        ).length;

        document.querySelector(".filter-count").innerHTML = this.activeFilters;

        if (this.activeFilters !== 0) {
            this.surpriseMeButton.style.display = "none";
        } else {
            this.surpriseMeButton.style.display = "inline-flex";
        }
    }

    //Count term usage across filteredData
    countTerms(filteredData) {
        let termCounts = {};

        filteredData.forEach((item) => {
            ["theme", "type", "location", "year"].forEach((taxonomy) => {
                if (Array.isArray(item[taxonomy])) {
                    item[taxonomy].forEach((term) => {
                        // If the term is already in the termCounts object, increment its count
                        if (termCounts[term]) {
                            termCounts[term]++;
                        } else {
                            // If the term isn't in the object, initialize its count to 1
                            termCounts[term] = 1;
                        }
                    });
                }
            });
        });

        return termCounts;
    }

    //set term count for each filter
    setFilterTermCount(filteredData) {
        const labelElements = this.form.querySelectorAll("label");
        const dataTerms = this.countTerms(filteredData);
        //console.log(dataTerms)

        labelElements.forEach((label) => {
            const key = label.getAttribute("for");
            const siblingInput = label.previousElementSibling;
            let relatedPostCount = label.querySelector(".post-count");
            if (this.jsonData.length === filteredData.length) {
                relatedPostCount.parentNode.style.opacity = 1;
                relatedPostCount.style.opacity = 1;
                relatedPostCount.parentNode.classList.remove("inactive");
                siblingInput.disabled = false;
            } else {
                if (key && dataTerms.hasOwnProperty(key)) {
                    // If it matches a key in dataTerms, update the post count
                    relatedPostCount.style.opacity = 0;
                    relatedPostCount.parentNode.style.opacity = 1;
                    relatedPostCount.parentNode.classList.remove("inactive");
                    siblingInput.disabled = false;
                } else {
                    // If no match, set the post count to 0
                    if (relatedPostCount) {
                        relatedPostCount.style.opacity = 0;
                        relatedPostCount.parentNode.style.opacity = 0.3;
                        relatedPostCount.parentNode.classList.add("inactive");
                        siblingInput.disabled = true;
                    }
                }
            }
        });
    }

    createLoadMoreButton() {
        const button = document.createElement("button");
        button.innerText = "Load More";
        button.style.display = "none";
        button.classList.add("btn", "btn-black");
        button.addEventListener("click", () => this.renderCards());

        // Append button to the pagination container
        this.paginationContainer.appendChild(button);
        return button;
    }

    showFeaturedContent() {
        if (this.featuredTemplate) {
            const clone = document.importNode(
                this.featuredTemplate.content,
                true,
            ); // Clone the template content
            this.container.appendChild(clone); // Append the cloned content to the container
        }
    }

    filterCards() {
        const selectedFilters = FilterListing.getSelectedFilters(this.form);
        this.container.innerHTML = ""; // Reset container

        this.filteredData = FilterListing.getMatchingData(
            selectedFilters,
            this.jsonData,
        ); // Store matching data

        this.setFilterTermCount(this.filteredData);

        this.currentIndex = 0; // Reset current index
        this.renderCards();

        // Dispatch the filter update for the map
        const event = new CustomEvent("filterUpdate", {
            detail: this.filteredData,
        });
        document.dispatchEvent(event);
    }

    renderCards() {
        //If is all cards set count to 8
        if (
            this.jsonData.length === this.filteredData.length &&
            this.featuredTemplate
        ) {
            this.cardsPerPage = this.featuredTemplate ? 8 : 9;
        }
        const nextSet = this.filteredData.slice(
            this.currentIndex,
            this.currentIndex + this.cardsPerPage,
        );

        if (this.filteredData.length === 0) {
            this.container.innerHTML =
                '<p style="width: 100%;">Sorry there are no results for that filter combination.</p>';
            return;
        }

        // If there are no more cards to load, hide the button and return
        if (nextSet.length === 0) {
            this.loadMoreButton.style.display = "none";
            return;
        }

        // Populate the container with the new cards
        nextSet.forEach((item) => {
            const cardHTML = FilterListing.createCardHTML(item);
            this.container.insertAdjacentHTML("beforeend", cardHTML);
        });

        //If is all cards and initial load show featured content
        if (
            this.jsonData.length === this.filteredData.length &&
            this.currentIndex === 0 &&
            this.featuredTemplate
        ) {
            this.showFeaturedContent();
        }

        // Update the current index
        this.currentIndex += nextSet.length;

        // Adjust cardsPerPage to 9 after the first load if the featured card exists
        if (this.cardsPerPage === 8) {
            this.cardsPerPage = 9; // Change to 9 for future loads
        }

        // Show the Load More button only if there are more cards to load
        this.loadMoreButton.style.display =
            this.currentIndex < this.filteredData.length ? "block" : "none";
    }

    static createCardHTML(item, showPostType = false) {
        const tagBgColor =
            (item.project_status && item.project_status === "Active") ||
            (item.project_status && item.project_status === "Available to Tour") || 
            (item.project_status && item.project_status === "In Development")
                ? `has-brand-1-background-color`
                : `has-neutral-700-background-color detail-color-neutral-700 color--white`;
        const projectStatusTag =
            item.project_status && item.project_status.length > 0
                ? `<span class="card__image-tag ${tagBgColor} diagonal-detail-before type-body-s fw-b">${item.project_status}</span>`
                : "";

        const partnershipTag =
            !showPostType && item.partnership && item.partnership.length > 0
                ? `<p class="card__parntership">${item.partnership}</p>`
                : "";
        const summaryTag =
            item.summary && item.summary.length > 0
                ? `<div class="card__summary">${item.summary}</div>`
                : "";

        const attributionTag =
            item.attribution && item.attribution.length > 0
                ? `<p class="card__attribution">${item.attribution}</p>`
                : "";

        const dateTag =
            item.date && item.date.length > 0
                ? `<p class="card__date fw-m">${item.date}</p>`
                : "";
        const is_project = document.body.classList.contains(
            "page-template-project-listing",
        );
        const is_news = document.body.classList.contains(
            "page-template-news-listing",
        );
        let post_type = is_project ? "project" : is_news ? "article" : "artist";
        const postTypeTag = showPostType
            ? `<p class="card__type fw-m">${item.posttype}</p>`
            : "";
        post_type = showPostType ? item.posttype : post_type;
        return `
            <article class="card card--${post_type} not-prose">
                <div class="card__image">
                    <div class="card__image-inner img-fit">
                        <img src="${item.image_url}" alt="${item.title}">
                    </div>
                    ${projectStatusTag}
                </div>
                <div class="card__content stack stack--s">
                    ${postTypeTag}
                    ${partnershipTag}
                    <div class="card__heading--wrapper">
                        <h4 class="card__heading">${item.title}</h4>
                        ${attributionTag}
                    </div>
                    ${dateTag}
                    ${summaryTag}
                    <div class="card__actions">
                        <a href="${item.link}" class="card__btn card__fill-link ">
                            <span class="sr-text">${item.title}</span>
                        </a>
                    </div>
                </div>
            </article>
        `;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (
        document.body.classList.contains("page-template-project-listing") ||
        document.body.classList.contains("page-template-artist-listing")
    ) {
        const mapManager = new MapManager("map");
        new FilterListing("#show-filters", mapManager, false);
    }

    if (document.body.classList.contains("page-template-news-listing")) {
        const mapManager = false;
        new FilterListing("#show-filters", mapManager, true);
    }
});

export default FilterListing;
